import './BlockText.css';

function BlockText(props) {
 
  return (
    <div id="BlockText">
        {props.blurred ? (
            <span style={{ filter: 'blur(6px)', userSelect: 'none' }}>
                {props.children}
            </span> 
        ) : (
            props.children
        )}
    </div>

  );
}

export default BlockText;
